import BannerComp from "../components/BannerComp";
import ServiceCardsGrid from "../components/ServiceCardsGrid";
import Seo from "../components/Seo";
import { serviceCards } from "../data/services";
import { createBreadcrumbSchema, createWebPageSchema } from "../lib/seo";

const seo = {
  title: "Our Services | MIT4Doctors",
  description:
    "Explore the full range of services MIT4Doctors offers to healthcare providers and their patients.",
  schema: [
    createWebPageSchema({
      path: "/services",
      title: "Our Services",
      description:
        "Explore the full range of services MIT4Doctors offers to healthcare providers and their patients.",
    }),
    createBreadcrumbSchema("/services", "Our Services"),
  ],
};

export default function Services() {
  return (
    <>
      <Seo
        title={seo.title}
        metaTitle={seo.title}
        description={seo.description}
        canonicalPath="/services"
        schema={seo.schema}
      />
      <BannerComp
        heading="Our Services"
        paragraph="Explore the full range of services MIT4Doctors offers to healthcare providers and their patients."
        centered
        BannerBgImg="/img/banners/service_hero.webp"
      />
      <ServiceCardsGrid cards={serviceCards} />
    </>
  );
}
